import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/base/ScrollToTop";
import CartIndicator from "./components/base/CartIndicator";
import RouteAnalytics from "./components/base/RouteAnalytics";
import PreviewGate from "./components/PreviewGate";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <PreviewGate>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <RouteAnalytics />
          <AppRoutes />
          <CartIndicator />
        </BrowserRouter>
      </PreviewGate>
    </I18nextProvider>
  );
}

export default App;
